import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import {
	Container,
	Label,
} from './styles';

const UserSelect = props => {
	const {
		t
	} = props;

	const users = props.users.filter(user => user.role !== 'developer');

	const options = users.map(user => ({
		value: user.username,
		name: `${user.lastName}, ${user.firstName}`
	}));

	// Fix for older data in db
	const value = Array.isArray(props.selectedUsers) ? props.selectedUsers : [props.selectedUsers];

	const onChange = (e) => {
		if(e.target.checked) {
			// Max 2 can be selected.
			if(value.length < 2) {
				props.handleChange([...value, e.target.value]);
			}
		} else {
			props.handleChange(value.filter(user => user !== e.target.value));
		}
	}

	return (
		<Container>
			<Label>{t('controls/contact/choose')} (max. 2)</Label>
			{options.map(option =>
				<Label key={option.value}>
					<input type="checkbox" value={option.value} checked={value.includes(option.value)} onChange={onChange}/>
					{option.name}
				</Label>
			)}
		</Container>
	);
};

UserSelect.propTypes = {
	t: PropTypes.func,
	users: PropTypes.array,
	value: PropTypes.array,
	handleChange: PropTypes.func
};

export default translate('translations')(UserSelect);
